export default __webpack_public_path__ + "static/hero-pattern-82bbfb27bd9c490f949c98f32554f308.png";